import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionSetting, AppHttp, Resources } from '../../app.service';
import { NotificationService } from '../../shared/utils/notification.service';
import { KeycloakService } from '../../keycloak.service';

declare var config: any;

@Component({
  selector: 'app-authority-select',
  templateUrl: './authorityselect.component.html',
  styleUrls: ['./authorityselect.component.css']
})
export class AuthoritySelectComponent implements OnInit {

  roles: any[];
  role: any;

  constructor(
    private http: AppHttp,
    private router: Router,
    private notifyService: NotificationService
  ) { }

  ngOnInit() {
    this.roles = [];
    // let user: any = SessionSetting.getUser();
    let user: any = {};
    if (config.devMode) {
      user = SessionSetting.getUser();
      if (user == null || user.UserID == null) {
        this.router.navigate(['login']);
        return;
      }
      this.http.post('main', '/api/RoleSelect/Init', {UserID: user.UserID}).then(r => {
        if (r.success) {
          user.IS_LOGINED = 1;
          if (r.data.length == 1) {
            user.RoleID = r.data[0].ID;
            user.RoleName = r.data[0].NAME;
            SessionSetting.setUser(user);
            this.router.navigate(['home']);
          } else {
            this.roles = r.data;
            this.role = this.roles[0];
            SessionSetting.setUser(user);
          }
        } else {
          alert('TODO: Failed to get role list.');
          
        }
      });
    } else {
      if (KeycloakService.auth == null
          || !KeycloakService.auth.loggedIn
          || KeycloakService.auth.authz == null) {
        KeycloakService.init();
        return;
      }
      let authz = KeycloakService.auth.authz;
      user.UserID = authz.idTokenParsed.preferred_username;
      user.IS_LOGINED = 1;
      let roles = authz.resourceAccess[authz.clientId].roles;
      if (roles.length == 1) {
        user.RoleID = roles[0];
        user.RoleName = Resources.getLabel(roles[0]);
        SessionSetting.setUser(user);
        this.router.navigate(['home']);
      } else {
        let data = [];
        roles.forEach(role => {
          data.push({ID: role, NAME: Resources.getLabel(role)});
        });
        this.roles = data;
        this.role = data[0];
        SessionSetting.setUser(user);
        if (roles.length == 0) alert("no role.");
        
      }
    }
  }

  login(e) {
    let user: any = SessionSetting.getUser();

    this.http.post('main', '/api/RoleSelect/Selected', {UserID: user.UserID, RoleID: this.role.ID}).then(r => {
      if (r.success) {
        user.RoleID = r.data[0].ID;
        user.RoleName = r.data[0].NAME;
        SessionSetting.setUser(user);
        this.router.navigate(['home']);
      } else {
        this.notifyService.smallBox({
          title: 'エラー',
          content: r.message,
          color: '#C46A69',
          icon: 'fa fa-times shake animated'
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/authorityselect/authorityselect.component.ts